import de from 'dayjs/locale/de';
import en from 'dayjs/locale/en';
import fr from 'dayjs/locale/fr';
import it from 'dayjs/locale/it';
var Locale;
(function (Locale) {
    Locale["De"] = "de";
    Locale["En"] = "en";
    Locale["Fr"] = "fr";
    Locale["It"] = "it";
})(Locale || (Locale = {}));
const locales = {
    de,
    en,
    fr,
    it,
};
export { Locale };
export default locales;
